module.exports = __webpack_public_path__ + "static/media/proj7_img2.9b3ec2da.jpg";